import { render, staticRenderFns } from "./provinceAndCity.vue?vue&type=template&id=05851594&scoped=true"
import script from "./provinceAndCity.vue?vue&type=script&lang=js"
export * from "./provinceAndCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05851594",
  null
  
)

export default component.exports